module.exports = __webpack_public_path__ + "assets/110653f508b27dafd342c1354ad33317.png";